module.exports = __webpack_public_path__ + "static/media/x-circle.c89cb7d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/x-circle.svg
// module id = 66
// module chunks = 0